export const UPDATE_SCALES_SUCCESS = 'UPDATE_SCALES_SUCCESS';
export const updateScalesSuccess = (workstationId, scales) => ({
  type: UPDATE_SCALES_SUCCESS,
  workstationId,
  scales,
});

export const SET_DEFAULT_SCALE = 'SET_DEFAULT_SCALE';
export const setDefaultScale = (defaultScale) => ({
  type: SET_DEFAULT_SCALE,
  defaultScale,
});

export const INITIATE_RESTORE_DEFAULT_SCALE = 'INITIATE_RESTORE_DEFAULT_SCALE';
export const initiateRestoreDefaultScale = () => ({
  type: INITIATE_RESTORE_DEFAULT_SCALE,
});

export const RESTORE_DEFAULT_SCALE = 'RESTORE_DEFAULT_SCALE';
export const restoreDefaultScale = (defaultScale) => ({
  type: RESTORE_DEFAULT_SCALE,
  defaultScale,
});

export const READ_SCALE_RESPONSE = 'READ_SCALE_RESPONSE';
export const readScaleResponse = (weight, dims, requestId, workstationId) => ({
  type: READ_SCALE_RESPONSE,
  weight,
  dims,
  requestId,
  workstationId,
});

export const READ_CONVERTED_SCALE_RESPONSE = 'READ_CONVERTED_SCALE_RESPONSE';
export const readConvertedScaleResponse = (weight, dims, weightUnit, dimsUnit, requestId) => ({
  type: READ_CONVERTED_SCALE_RESPONSE,
  weight,
  dims,
  dimsUnit,
  weightUnit,
  requestId,
});

export const UPDATE_PRINTERS_SUCCESS = 'UPDATE_PRINTERS_SUCCESS';
export const updatePrintersSuccess = (workstationId, printers) => ({
  type: UPDATE_PRINTERS_SUCCESS,
  workstationId,
  printers,
});

export const UPDATE_PRINTERS_FAILURE = 'UPDATE_PRINTERS_FAILURE';
export const updatePrintersFailure = (getPrintersError) => ({
  type: UPDATE_PRINTERS_FAILURE,
  getPrintersError,
});

export const PRINT_DOCUMENT_REQUEST = 'PRINT_DOCUMENT_REQUEST';
export const printDocumentRequest = (printJob) => ({
  type: PRINT_DOCUMENT_REQUEST,
  printJob,
});

export const PRINT_DOCUMENT_PENDING = 'PRINT_DOCUMENT_PENDING';
export const printDocumentPending = (requestId) => ({
  type: PRINT_DOCUMENT_PENDING,
  requestId,
});

export const PRINT_DOCUMENT_SUCCESS = 'PRINT_DOCUMENT_SUCCESS';
export const printDocumentSuccess = (request) => ({
  type: PRINT_DOCUMENT_SUCCESS,
  request,
});

export const PRINT_DOCUMENT_FAILURE = 'PRINT_DOCUMENT_FAILURE';
export const printDocumentFailure = ({ requestId, errorMessage, error, workstationId }) => {
  return {
    type: PRINT_DOCUMENT_FAILURE,
    error,
    errorMessage,
    requestId,
    workstationId,
  };
};

export const PRINT_DOCUMENT_COMPLETE = 'PRINT_DOCUMENT_COMPLETE';
export const printDocumentComplete = (requestId) => ({
  type: PRINT_DOCUMENT_COMPLETE,
  requestId,
});

export const GET_WORKSTATIONS_REQUEST = 'GET_WORKSTATIONS_REQUEST';
export const getWorkstationsRequest = () => ({
  type: GET_WORKSTATIONS_REQUEST,
});

export const GET_WORKSTATIONS_SUCCESS = 'GET_WORKSTATIONS_SUCCESS';
export const getWorkstationsSuccess = (workstations) => ({
  type: GET_WORKSTATIONS_SUCCESS,
  workstations,
});

export const UPDATE_WORKSTATION_SUCCESS = 'UPDATE_WORKSTATION_SUCCESS';
export const updateWorkstationSuccess = (workstation) => ({
  type: UPDATE_WORKSTATION_SUCCESS,
  workstation,
});

export const CLEAR_DEVICES_FOR_WORKSTATION = 'CLEAR_DEVICES_FOR_WORKSTATION';
export const clearDevicesForWorkstation = (workstationId) => ({
  type: CLEAR_DEVICES_FOR_WORKSTATION,
  workstationId,
});

export const WORKSTATION_REMOVED = 'WORKSTATION_REMOVED';
export const handleWorkstationRemovedMessage = (workstationId) => ({
  type: WORKSTATION_REMOVED,
  workstationId,
});
